module.exports = __webpack_public_path__ + "static/hacktober-fest-banner-9a2056972f92077b2af8b32ecc2fcbdd.webp";